<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright pull-right">
        Copyright &copy; 2020 Interdisciplinary Humanistic Technologies All rights reserved.
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue